module.exports = __webpack_public_path__ + "img/flag.9a691635.svg";